/* Library */
import React, { Component } from 'react';
import CheckBox from './../../../../components/ZUILib/CheckBox';
import GiftDeliveryPreferences from './components/GiftDeliveryPreferences';

export default class GiftPreferencesSuspended extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        name: '¿Deseas asignar días de entrega?',
        id: 'showAddress',
        checked: true,
        disabled: true,
      },
      preferencedAddress: {
        ShowStyle: 'vertical',
        addresses: [
          {
            displayName: 'Casa María',
            addressTitle: 'Maria Eugenia Hernández',
            checkBoxData: [
              {
                classname: 'checkbox',
                displayName: 'Lunes',
                id: 'showAddressL',
                name: 'check',
                value: '',
                disabled: true,
                checked: true,
              }, {
                classname: 'checkbox',
                displayName: 'Martes',
                id: 'showAddressM',
                name: 'check',
                value: '',
                disabled: true,
                checked: false,
              }, {
                classname: 'checkbox',
                displayName: 'Jueves',
                id: 'showAddressJ',
                name: 'check',
                value: '',
                disabled: true,
                checked: false,
              },
            ],
          },
          {
            displayName: 'Nueva Casa',
            addressTitle: 'Sergio Méndez',
            checkBoxData: [
              {
                classname: 'checkbox',
                displayName: 'Lunes',
                id: 'showAddressL1',
                name: 'check',
                value: '',
                disabled: true,
                checked: true,
              }, {
                classname: 'checkbox',
                displayName: 'Jueves',
                id: 'showAddressJ2',
                name: 'check',
                value: '',
                disabled: true,
                checked: false,
              },
            ],
          },
          {
            displayName: 'Nueva Casa',
            addressTitle: 'Sergio Méndez',
            checkBoxData: [
              {
                classname: 'checkbox',
                displayName: 'Lunes',
                id: 'showAddressL2',
                name: 'check',
                value: '',
                disabled: true,
                checked: true,
              }, {
                classname: 'checkbox',
                displayName: 'Martes',
                id: 'showAddressM2',
                name: 'check',
                value: '',
                disabled: true,
                checked: false,
              }, {
                classname: 'checkbox',
                displayName: 'Miércoles',
                id: 'showAddressMI2',
                name: 'check',
                value: '',
                disabled: true,
                checked: true,
              }, {
                classname: 'checkbox',
                displayName: 'Jueves',
                id: 'showAddressJ2',
                name: 'check',
                value: '',
                disabled: true,
                checked: false,
              }, {
                classname: 'checkbox',
                displayName: 'Viernes',
                id: 'showAddressV2',
                name: 'check',
                value: '',
                disabled: true,
                checked: false,
              },
            ],
          },
        ],
      },
    };
  }
  render() {
    return (
      <div className="col-sm-9">
        <div className="row">
          <div className="col-sm-9 myEventInfo noBorder addressIntro">
            <h1>Preferencias de entrega de regalos</h1>
            <p>La programación de entregas por días de la semana sólo la puedes llevar a cabo una sóla vez, en cuanto guardes la configuración no podrás modificarlo ni deshabilitar la opción.</p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 giftPreference">
            <div className="checkbox">
              <CheckBox id={this.state.data.id} value={this.state.data.id} displayName={this.state.data.name} checked={this.state.data.checked} disabled={this.state.data.disabled} />
            </div>
          </div>
        </div>
        <div className="giftPAAddress show">
          <div className="row">
            {this.state.preferencedAddress.addresses.map((addresses, index) => (<GiftDeliveryPreferences key={'pfa' + index} addresses={addresses} {...this.props} />))}
          </div>
        </div>
      </div>
    );
  }
}

